import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {RepasDTO} from "../../../../../core/dtos/repas-dto";
import {JourSemaine} from "../../../../../core/constants";
import {RegimeAlimentaireDTO} from "../../../../../core/dtos/regime-alimentaire-dto";
import {TreeListComponent} from "../../../../../shared/ui/tree-list/tree-list.component";

@Component({
  selector: 'yo-dialog-update-effectifs',
  templateUrl: './dialog-update-effectifs.component.html',
  styleUrls: ['./dialog-update-effectifs.component.scss']
})
export class DialogUpdateEffectifsComponent implements OnInit {

  @Output() onClose = new EventEmitter<boolean>();
  @Output() onSave = new EventEmitter<any>();

  @Input() displayEffectifDialog: boolean;
  @Input() repasList: RepasDTO[];
  @Input() joursSemaine: JourSemaine[] = [];

  @ViewChild("treeListJoursSemaineEff", {static: false}) treeListJoursSemaineEff: TreeListComponent;
  @ViewChild("treeListRepasListEff", {static: false}) treeListRepasListEff: TreeListComponent;

  repas: any[] = [];

  majEffectifPrev: number;
  selectedJoursSemaine: JourSemaine[] = [];
  selectedRepasList: RepasDTO[] = [];
  selectedRegimeList: RegimeAlimentaireDTO[] = [];

  constructor() {
  }

  ngOnInit(): void {
    this.initData();
  }

  initData = (): void => {
    this.repas = this.repasList.map(item => ({
      "libelle": item.libelle,
      "children": item.regimesAlimentaire.map(regime => ({
        id: regime.id,
        libelle: regime.libelle,
        parentId: item.id
      }))
    }));
  }

  closeDialog: () => void = async () => {
    this.selectedJoursSemaine = [];
    this.selectedRegimeList = [];
    this.selectedRepasList = [];
    this.majEffectifPrev = null;
    this.displayEffectifDialog = false;
    this.treeListJoursSemaineEff.clearSelection();
    this.treeListRepasListEff.clearSelection();
    this.onClose.emit(this.displayEffectifDialog);
  }

  onChangeJoursSemaine = ($event: any) => this.selectedJoursSemaine = $event;

  onChangeParentDenreeSelection = ($event: any) => {
    this.selectedRegimeList = [];
    this.selectedRepasList = [];
    $event.forEach(row => {
      if (!this.selectedRegimeList.find(item => item.id === row.id)) {
        this.selectedRegimeList.push(row);
        if (!this.selectedRepasList.find(item => item.id === row.parentId)) {
          this.selectedRepasList.push(this.repasList.find(item => item.id === row.parentId));
        }
      }
    });
  };

  save = (selectedJoursSemaine: JourSemaine[], selectedRepasList: RepasDTO[], selectedRegimeList: RegimeAlimentaireDTO[], majEffectifPrev: number) => {
    this.onSave.emit({selectedJoursSemaine, selectedRepasList, selectedRegimeList, majEffectifPrev});
    this.closeDialog();
  };
}
